(() => {
  const initialiseFooterMakes = (scope = document) => {
    scope.querySelectorAll('[data-footer-makes-list]').forEach((list) => {
      if (list.dataset.footerMakesReady === 'true') return;

      const button = list.querySelector('[data-footer-makes-expand]');
      const extraLinks = list.querySelectorAll('[data-footer-makes-extra]');
      if (!button || extraLinks.length === 0) return;

      list.dataset.footerMakesReady = 'true';
      list.classList.add('is-collapsible');

      button.addEventListener('click', () => {
        button.setAttribute('aria-expanded', 'true');
        list.classList.remove('is-collapsible');
        list.classList.add('is-expanded');
      }, { once: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseFooterMakes(), { once: true });
  } else {
    initialiseFooterMakes();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseFooterMakes(event.target));
})();
